import { DateTime } from 'luxon'

const dateTimeToString = (utcDateTime: string): string => {
  const dt = DateTime.fromISO(utcDateTime).setLocale('en-GB')
  return dt.toLocaleString(DateTime.DATETIME_SHORT)
}

export { dateTimeToString }
